import Vue from 'vue'
import Router from 'vue-router'
import AuthService from "@/services/AuthService";
Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        { 
            path: '*', 
            beforeEnter: async (to, from, next) => {
                if (await AuthService.isLoggedIn()) {
                    next({ name: 'Redirecting' });
                } else {
                    next({ name: 'Login' });
                }
            }
        },
        { 
            path: '/logout', 
            name: 'Logout',
            component: () =>  import("@/view/Logout")
        },
        {
            path: '/login',
            name: 'Login',
            component: () =>  import("@/view/Login"),
            beforeEnter: async (to, from, next) => {
                if (await AuthService.isLoggedIn()) {
                    next({ name: 'Redirecting' });
                } else {
                    next();
                }
            }
        },
        {
            path: '/redirecting',
            name: 'Redirecting',
            component: () =>  import("@/view/Redirecting"),
            beforeEnter: async (to, from, next) => {
                if (await AuthService.isLoggedIn()) {
                    next();
                } else {
                    next({ name: 'Login' });
                }
            }
        },
        {
            path: '/changePassword',
            name: 'ChangePassword',
            component: () =>  import("@/view/ChangePassword"),
            beforeEnter: async (to, from, next) => {
                if (await AuthService.isLoggedIn()) {
                    next();
                } else {
                    next({ name: 'Login' });
                }
            }
        },
        {
            path: '/forgot-password',
            name: 'ForgotPassword',
            component: () =>  import("@/view/ForgotPassword")
        }
    ]
})